"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterRange = void 0;
var Slider_1 = __importDefault(require("@material-ui/core/Slider"));
var react_1 = __importStar(require("react"));
var Common_1 = require("../../layout/Common");
var APFlex_1 = require("../../layout/APFlex");
var APFilterMenu_1 = require("./APFilterMenu");
function APFilterRange(_a) {
    var header = _a.header, onChange = _a.onChange, initialValue = _a.initialValue, totalRange = _a.totalRange;
    var _b = react_1.useState(initialValue ? [initialValue.min, initialValue.max] : [totalRange.min, totalRange.max]), value = _b[0], setValue = _b[1];
    react_1.useEffect(function () {
        onChange({ min: value[0], max: value[1] });
    }, [value[0], value[1]]);
    react_1.useEffect(function () {
        if (initialValue)
            setValue([initialValue.min, initialValue.max]);
    }, [initialValue === null || initialValue === void 0 ? void 0 : initialValue.min, initialValue === null || initialValue === void 0 ? void 0 : initialValue.max]);
    return react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'stretch' },
        react_1.default.createElement(APFilterMenu_1.HeaderItem, { text: header }),
        react_1.default.createElement(Common_1.APPadding, { padding: "4px 24px 12px" },
            react_1.default.createElement(APFlex_1.APRow, { crossAxisAlignment: 'center', mainAxisSize: 'max', gap: "6px" },
                react_1.default.createElement(Slider_1.default, { color: 'primary', value: value, min: totalRange.min, max: totalRange.max, marks: [
                        {
                            value: totalRange.min,
                            label: totalRange.min,
                        }, {
                            value: totalRange.max,
                            label: totalRange.max
                        }
                    ], onChange: function (e, v) {
                        if (Array.isArray(v))
                            setValue(v);
                    }, valueLabelDisplay: "auto" }))));
}
exports.APFilterRange = APFilterRange;
